import { createKeyedDataAsyncSlice } from '../../createKeyedDataAsyncSlice';
import { getCommentsForClientOrderAsync } from '../../../API/clientPortal/clientOrderAPI';

export const { slice: getClientOrderCommentsSlice, asyncAction: getClientOrderCommentsAction } =
  createKeyedDataAsyncSlice(
    'getClientOrderComments',
    getCommentsForClientOrderAsync,
    (orderId) => `${orderId}`
  );
